import React from 'react'

import star from './../../../UI/canvasMobile/topMenu/star.svg'
import star_blue from './../../../UI/canvasMobile/topMenu/star_blue.svg'

interface Props {
  handleShowSurvey: any,
  showSurvey: boolean,
}

interface State {}

class SurveyBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.showSurvey ? 'survey-btn-opened-mobile':'survey-btn-mobile'} onClick={() => {this.props.handleShowSurvey()}}>
          <img src={this.props.showSurvey ? star_blue:star} alt=''></img>
        </div>
      )
  }
}

export default SurveyBtnMobile